import React from 'react'
import UserProfileComponent from '../components/UserProfileComponent'

function UserProfile() {
  return (
    <UserProfileComponent />
  )
}

export default UserProfile